var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

export const emailValidator = (email) => {
  if (email.match(mailformat)) {
    return true;
  } else {
    return false;
  }
};
